import { SupplierDTO, CreateSupplierRequestDTO, UpdateSupplierRequestDTO, SupplierProductDTO, LinkProductRequestDTO } from '../dto/SupplierDTO';
import { ApiClient } from '../../ApiClient';

export class SupplierDataSource {
  constructor(private api: ApiClient) { }

  async getSuppliers(): Promise<SupplierDTO[]> {
    try {
      const response = await this.api.get<SupplierDTO[]>('/suppliers');
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      // Fallback to mock data for development
      return [];
    }
  }

  async getSupplier(id: string): Promise<SupplierDTO> {
    try {
      const response = await this.api.get<SupplierDTO>(`/suppliers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createSupplier(supplier: CreateSupplierRequestDTO): Promise<SupplierDTO> {
    try {
      const response = await this.api.post<SupplierDTO>('/suppliers', supplier);
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error);
      throw error;
    }
  }

  async updateSupplier(id: string, updates: UpdateSupplierRequestDTO): Promise<SupplierDTO> {
    try {
      const response = await this.api.put<SupplierDTO>(`/suppliers/${id}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating supplier:', error);
      throw error;
    }
  }

  async deleteSupplier(id: string): Promise<void> {
    try {
      await this.api.delete(`/suppliers/${id}`);
    } catch (error) {
      console.error('Error deleting supplier:', error);
      throw error;
    }
  }

  async linkProducts(supplierId: string, body?: LinkProductRequestDTO[]): Promise<SupplierProductDTO[]> {
    try {
      const response = await this.api.post<SupplierProductDTO[]>(`/suppliers/${supplierId}/products`, body ?? []);
      return response.data;
    } catch (error) {
      console.error('Error linking product:', error);
      throw error;
    }
  }

  async unlinkProducts(supplierId: string, productIds: string[]): Promise<void> {
    if (productIds.length === 0) return;
    try {
      await this.api.delete(`/suppliers/${supplierId}/products`, { data: { productIds } });
    } catch (error) {
      console.error('Error unlinking products:', error);
      throw error;
    }
  }

  async unlinkProduct(supplierId: string, productId: string): Promise<void> {
    await this.unlinkProducts(supplierId, [productId]);
  }
} 